import React, { FC } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { useTheme } from 'styled-components';

import { ReactTable, CoreUtils } from '@nhl/nhl-breakaway-ui';

import commonMessages from '~/core/commonMessages';

import { ReactTableContainer, SectionHeader } from '../../styles';
import { LandingGame, Penalty } from '../../types';

import { columns, noPenaltyColumns } from './columns';

import { PenaltyContainer, PeriodDescription } from './styles';

type Props = {
    game: LandingGame;
};

const NO_PENALTY_DATA: Array<Penalty> = [{} as Penalty];

const Penalties: FC<Props> = ({ game }) => {
    const theme = useTheme();
    const intl = useIntl();

    return game.summary.penalties.length ? (
        <PenaltyContainer>
            <SectionHeader aria-level={2}>
                <FormattedMessage {...commonMessages.tableHeaders.long.penalties} />
            </SectionHeader>
            {game.summary.penalties.map((penalty) => (
                <React.Fragment key={penalty.periodDescriptor.number}>
                    <PeriodDescription role="heading" aria-level={3}>
                        {penalty?.periodDescriptor &&
                            CoreUtils.getPeriodDisplayFromDescriptor(
                                intl,
                                penalty.periodDescriptor,
                                game.gameType,
                                true
                            )}
                    </PeriodDescription>
                    <ReactTableContainer>
                        {penalty.penalties.length > 0 ? (
                            <ReactTable data={penalty.penalties} columns={columns(game, theme)} />
                        ) : (
                            <ReactTable data={NO_PENALTY_DATA} columns={noPenaltyColumns(theme)} />
                        )}
                    </ReactTableContainer>
                </React.Fragment>
            ))}
        </PenaltyContainer>
    ) : (
        <></>
    );
};

export default Penalties;
